import { useContext } from "react";
import { DiaryContext } from "../context/DiaryContext";

/**
 * venueConfig:     the selected venue config
 * bookings:        the bookings for the current value of 'date'
 * venues:          the available venues to select from (note: this is no the same as venue config)
 * date:            the selected date
 */
export const useDiaryContext = () => useContext(DiaryContext);
